import Alert, {AlertScanSubType, AlertType} from 'features/POSRegisters/interfaces/AlertInfo';
import {
  CloudServicesDeviceScanDetails,
  NetworkCircuitScanDetails,
  NetworkSwitchScanDetails,
  IpadScanDetails,
  CfdScanDetails,
  ReceiptPrinterScanDetails,
  PaymentTerminalScanDetails,
  CashDrawerScanDetails,
  BarCodeScanDetails,
} from 'features/POSRegisters/interfaces/ScanDetails';
import Device from 'features/POSRegisters/interfaces/Device';
import DeviceType from 'features/POSRegisters/interfaces/DeviceType';

const cloudServicesList: Device<CloudServicesDeviceScanDetails>[] = [
  {
    scanResults: {
      deviceName: 'Cloud Services',
    },
    alerts: [],
  },
];

const networkCircuitList: Device<NetworkCircuitScanDetails>[] = [
  {
    scanResults: {
      deviceName: 'NNR0001D01',
      localExchangeCarrier: 'AT&T Wireless',
      ipV4Address: '166.176.185.87',
      tunnelStatus: 'Standby',
      uploadSpeedThroughput: '0',
      downloadSpeedThroughput: '0',
      uploadSpeedBandwidth: '4.89 Mbps',
      downloadSpeedBandwidth: '25.31 Mbps',
      interface: 'SFP2',
      macAddress: null,
    },
    alerts: [],
  },
  {
    scanResults: {
      deviceName: 'NNR0001D01',
      localExchangeCarrier: 'Comcast Cable',
      ipV4Address: '76.115.115.230',
      tunnelStatus: 'Stable',
      uploadSpeedThroughput: '79.48 Kbps',
      downloadSpeedThroughput: '2.36 Mbps',
      uploadSpeedBandwidth: '98.26 Mbps',
      downloadSpeedBandwidth: '98.28 Mbps',
      interface: 'GE1',
      macAddress: null,
    },
    alerts: [
      {
        effect: 'The Network Circuit will not function',
        solution: 'The Network Circuit will not function ',
        kb: '',
        alertType: AlertType.DIAGNOSTIC_ALERT,
        alertDefinitionId: 'NposRegisterWorkstationNumberDataNotFound',
        deviceType: DeviceType.NETWORK_CIRCUIT,
        siteImpact: 'Major',
        shortDescription: 'The Network Circuit will not function',
        description: 'The Network Circuit will not function ',
      },
    ],
  },
  {
    scanResults: {
      deviceName: 'NNR0001D01',
      localExchangeCarrier: 'Verizon Internet Services',
      ipV4Address: '157.130.183.46',
      tunnelStatus: 'Stable',
      uploadSpeedThroughput: '1.19 Mbps',
      downloadSpeedThroughput: '3.10 Mbps',
      uploadSpeedBandwidth: '97.06 Mbps',
      downloadSpeedBandwidth: '77.45 Mbps',
      interface: 'GE2',
      macAddress: null,
    },
    alerts: [],
  },
];

const networkSwitchesList: Device<NetworkSwitchScanDetails>[] = [
  {
    scanResults: {
      switchId: 'NNR0001X01',
      switchNumber: 1,
    },
    alerts: [],
  },
];

const registersList: Device<IpadScanDetails>[] = [
  {
    scanResults: {
      iosVersion: '17.6.1',
      lastSeen: '2024-12-10T01:54:20Z',
      workstationNumber: 1,
      registerAppVersion: '25.2.0 (2103250309)',
      registerId: 'HW6JFXM-WS1',
      registerFirstSeenDate: '2024-12-04T01:13:32.3076406Z',
      registerLastSeenDate: '2024-12-10T19:13:32.3076846Z',
      printerId: '69803450-85b1-11ef-b4a2-696d840f6823',
      printerFirstSeenDate: '2024-12-04T01:13:32.3077459Z',
      printerLastSeenDate: '2024-12-10T19:13:32.3077764Z',
      cashDrawerId: 'No Cash Drawer In DB Yet',
      cashDrawerFirstSeenDate: '2024-12-04T01:13:32.3078349Z',
      cashDrawerLastSeenDate: '2024-12-10T19:13:32.3078766Z',
      consumerFacingDisplayAppVersion: '24.5.0 (2303230945)',
      consumerFacingDisplayId: 'F97YX04M4G',
      consumerFacingDisplayFirstSeenDate: '2024-12-04T01:13:32.3079798Z',
      consumerFacingDisplayLastSeenDate: '2024-12-10T19:13:32.3080103Z',
      isOnline: false,
      ipAddress: 'unavailable',
      macAddress: 'unavailable',
      vlanNumber: 'N/A',
      switchId: 'N/A',
      switchNumber: undefined,
      portNumber: undefined,
      deviceName: 'HW6JFXM-WS1',
      isAssociated: true,
      associatedDevice: 'HW6JFXM-WS1',
      manufacturer: 'Apple',
      model: 'iPad Air 11-inch (M2)',
      serialNumber: 'HW6JFXM-WS1',
      defaultGateway: 'unavailable',
      dns: 'unavailable',
    },
    alerts: [],
  },
  {
    scanResults: {
      iosVersion: '17.6.1',
      lastSeen: '2024-12-10T01:54:20Z',
      workstationNumber: 2,
      registerAppVersion: '25.2.0 (2103250309)',
      registerId: 'HW6JFXM-WS2',
      registerFirstSeenDate: '2024-12-04T01:13:32.3076406Z',
      registerLastSeenDate: '2024-12-10T19:13:32.3076846Z',
      printerId: '69803450-85b1-11ef-b4a2-696d840f6823',
      printerFirstSeenDate: '2024-12-04T01:13:32.3077459Z',
      printerLastSeenDate: '2024-12-10T19:13:32.3077764Z',
      cashDrawerId: 'No Cash Drawer In DB Yet',
      cashDrawerFirstSeenDate: '2024-12-04T01:13:32.3078349Z',
      cashDrawerLastSeenDate: '2024-12-10T19:13:32.3078766Z',
      consumerFacingDisplayAppVersion: '24.5.0 (2303230945)',
      consumerFacingDisplayId: 'F97YX04M4G',
      consumerFacingDisplayFirstSeenDate: '2024-12-04T01:13:32.3079798Z',
      consumerFacingDisplayLastSeenDate: '2024-12-10T19:13:32.3080103Z',
      isOnline: false,
      ipAddress: 'unavailable',
      macAddress: 'unavailable',
      vlanNumber: 'N/A',
      switchId: 'N/A',
      switchNumber: undefined,
      portNumber: undefined,
      deviceName: 'HW6JFXM-WS2',
      isAssociated: true,
      associatedDevice: 'HW6JFXM-WS2',
      manufacturer: 'Apple',
      model: 'iPad Air 11-inch (M2)',
      serialNumber: 'HW6JFXM-WS2',
      defaultGateway: 'unavailable',
      dns: 'unavailable',
      mobileApiLastSeen: '2025-03-13T19:40:28Z',
    },
    alerts: [],
  },
  {
    scanResults: {
      iosVersion: '17.6.1',
      lastSeen: '2024-12-10T01:54:20Z',
      workstationNumber: 3,
      registerAppVersion: '25.2.0 (2103250309)',
      registerId: 'HW6JFXM-WS3',
      registerFirstSeenDate: '2024-12-04T01:13:32.3076406Z',
      registerLastSeenDate: '2024-12-10T19:13:32.3076846Z',
      printerId: '69803450-85b1-11ef-b4a2-696d840f6823',
      printerFirstSeenDate: '2024-12-04T01:13:32.3077459Z',
      printerLastSeenDate: '2024-12-10T19:13:32.3077764Z',
      cashDrawerId: 'No Cash Drawer In DB Yet',
      cashDrawerFirstSeenDate: '2024-12-04T01:13:32.3078349Z',
      cashDrawerLastSeenDate: '2024-12-10T19:13:32.3078766Z',
      consumerFacingDisplayAppVersion: '24.5.0 (2303230945)',
      consumerFacingDisplayId: 'F97YX04M4G',
      consumerFacingDisplayFirstSeenDate: '2024-12-04T01:13:32.3079798Z',
      consumerFacingDisplayLastSeenDate: '2024-12-10T19:13:32.3080103Z',
      isOnline: false,
      ipAddress: 'unavailable',
      macAddress: 'unavailable',
      vlanNumber: 'N/A',
      switchId: 'N/A',
      switchNumber: undefined,
      portNumber: undefined,
      deviceName: 'HW6JFXM-WS3',
      isAssociated: true,
      associatedDevice: 'HW6JFXM-WS3',
      manufacturer: 'Apple',
      model: 'iPad Air 11-inch (M2)',
      serialNumber: 'HW6JFXM-WS3',
      defaultGateway: 'unavailable',
      dns: 'unavailable',
      mobileApiLastSeen: '2025-03-13T19:40:28Z',
    },
    alerts: [],
  },
];

const consumerFacingDisplaysList: Device<CfdScanDetails>[] = [
  {
    scanResults: {
      iosVersion: '17.5.1',
      mobileApiLastSeen: '2025-03-14T09:40:10Z',
      consumerFacingDisplayAppVersion: '25.1.0',
      consumerFacingDisplayId: 'F97YX04M4G',
      consumerFacingDisplayFirstSeenDate: '2025-01-23T21:17:33Z',
      consumerFacingDisplayLastSeenDate: '2025-03-13T01:32:28Z',
      isOnline: false,
      ipAddress: 'unavailable',
      macAddress: 'unavailable',
      vlanNumber: 'N/A',
      switchId: 'N/A',
      switchNumber: 'unavailable',
      portNumber: 'unavailable',
      deviceName: 'F97YX04M4H',
      isAssociated: true,
      associatedDevice: 'HW6JFXM-WS1',
      manufacturer: 'Apple',
      model: 'iPad mini 6th generation (Wi-Fi)',
      serialNumber: 'F97YX04M4H',
    },
    alerts: [],
  },
  {
    scanResults: {
      iosVersion: '17.5.1',
      mobileApiLastSeen: '2025-03-14T09:40:10Z',
      consumerFacingDisplayAppVersion: '25.1.0',
      consumerFacingDisplayId: 'F97YX04M4H',
      consumerFacingDisplayFirstSeenDate: '2025-01-23T21:17:33Z',
      consumerFacingDisplayLastSeenDate: '2025-03-13T01:32:28Z',
      isOnline: false,
      ipAddress: 'unavailable',
      macAddress: 'unavailable',
      vlanNumber: 'N/A',
      switchId: 'N/A',
      switchNumber: 'unavailable',
      portNumber: 'unavailable',
      deviceName: 'F97YX04M4I',
      isAssociated: true,
      associatedDevice: 'HW6JFXM-WS2',
      manufacturer: 'Apple',
      model: 'iPad mini 6th generation (Wi-Fi)',
      serialNumber: 'F97YX04M4I',
    },
    alerts: [],
  },
  {
    scanResults: {
      iosVersion: '17.5.1',
      mobileApiLastSeen: '2025-03-14T09:40:10Z',
      consumerFacingDisplayAppVersion: '25.1.0',
      consumerFacingDisplayId: 'F97YX04M4H',
      consumerFacingDisplayFirstSeenDate: '2025-01-23T21:17:33Z',
      consumerFacingDisplayLastSeenDate: '2025-03-13T01:32:28Z',
      isOnline: false,
      ipAddress: 'unavailable',
      macAddress: 'unavailable',
      vlanNumber: 'N/A',
      switchId: 'N/A',
      switchNumber: 'unavailable',
      portNumber: 'unavailable',
      deviceName: 'F97YX04M4I',
      isAssociated: true,
      associatedDevice: 'HW6JFXM-WS3',
      manufacturer: 'Apple',
      model: 'iPad mini 6th generation (Wi-Fi)',
      serialNumber: 'F97YX04M4I',
    },
    alerts: [],
  },
];

const receiptPrintersList: Device<ReceiptPrinterScanDetails>[] = [
  {
    scanResults: {
      printerId: '69803450-85b1-11ef-b4a2-696d840f6823',
      printerFirstSeenDate: '2024-12-04T01:13:32.3077459Z',
      printerLastSeenDate: '2024-12-10T19:13:32.3077764Z',
      isOnline: true,
      ipAddress: '10.146.57.72',
      macAddress: 'A4:D7:3C:A3:38:B2',
      vlanNumber: '5',
      switchId: 'NNR0001X01',
      switchNumber: 2,
      portNumber: 9,
      deviceName: 'RTUS0TST1SCP001',
      isAssociated: true,
      associatedDevice: 'HW6JFXM-WS1',
      manufacturer: 'Epson',
      model: 'EPSON TM-m30III',
      serialNumber: 'XBVN007564',
    },
    alerts: [],
  },
  {
    scanResults: {
      printerId: '69803450-85b1-11ef-b4a2-696d840f6823',
      printerFirstSeenDate: '2024-12-04T01:13:32.3077459Z',
      printerLastSeenDate: '2024-12-10T19:13:32.3077764Z',
      isOnline: true,
      ipAddress: '10.146.57.72',
      macAddress: 'A4:D7:3C:A3:38:B2',
      vlanNumber: '5',
      switchId: 'NNR0001X01',
      switchNumber: 2,
      portNumber: 9,
      deviceName: 'RTUS0TST1SCP001',
      isAssociated: true,
      associatedDevice: 'HW6JFXM-WS2',
      manufacturer: 'Epson',
      model: 'EPSON TM-m30III',
      serialNumber: 'XBVN007564',
    },
    alerts: [],
  },
  {
    scanResults: {
      printerId: '69803450-85b1-11ef-b4a2-696d840f6823',
      printerFirstSeenDate: '2024-12-04T01:13:32.3077459Z',
      printerLastSeenDate: '2024-12-10T19:13:32.3077764Z',
      isOnline: true,
      ipAddress: '10.146.57.72',
      macAddress: 'A4:D7:3C:A3:38:B2',
      vlanNumber: '5',
      switchId: 'NNR0001X01',
      switchNumber: 2,
      portNumber: 9,
      deviceName: 'RTUS00129SCP004',
      isAssociated: false,
      associatedDevice: 'unavailable',
      manufacturer: 'Epson',
      model: 'EPSON TM-m30III',
      serialNumber: 'XBVN007565',
    },
    alerts: [
      {
        effect:
          "The workstation won't be able to use the Receipt Printer until they are associated.",
        solution:
          'Ensure that any alerts related to the workstation number and mobile device management (JAMF) have been resolved. Then, have the athlete log into Nike POS, which should update the association information.',
        kb: '',
        alertType: AlertType.CONFIGURATION_ALERT,
        alertDefinitionId: 'NposPrinterAssociationNotFound',
        deviceType: DeviceType.RECEIPT_PRINTER,
        scanSubType: AlertScanSubType.CONNECTIVITY,
        siteImpact: 'critical',
        shortDescription:
          'The Receipt Printer does not have any association information. (Mock Alert)',
        description:
          'Missing information about the peripherals (Receipt Printer, Payment Terminal, Consumer Facing Display and Cash Drawer) associated to this register.',
      },

      {
        effect:
          "The workstation won't be able to use the Receipt Printer until they are associated.",
        solution:
          'Ensure that any alerts related to the workstation number and mobile device management (JAMF) have been resolved. Then, have the athlete log into Nike POS, which should update the association information.',
        kb: '',
        alertType: AlertType.ORPHAN_DEVICE_ALERT,
        alertDefinitionId: 'NposPrinterAssociationNotFound',
        deviceType: DeviceType.RECEIPT_PRINTER,
        scanSubType: AlertScanSubType.CONNECTIVITY,
        siteImpact: 'Minor',
        shortDescription:
          'The Receipt Printer does not have any association information. (Mock Alert)',
        description:
          'Missing information about the peripherals (Receipt Printer, Payment Terminal, Consumer Facing Display and Cash Drawer) associated to this register.',
      },
    ],
  },
  {
    scanResults: {
      printerId: '69803450-85b1-11ef-b4a2-696d840f6823',
      printerFirstSeenDate: '2024-12-04T01:13:32.3077459Z',
      printerLastSeenDate: '2024-12-10T19:13:32.3077764Z',
      isOnline: true,
      ipAddress: '10.146.57.72',
      macAddress: 'A4:D7:3C:A3:38:B2',
      vlanNumber: '5',
      switchId: 'NNR0129X01',
      switchNumber: 2,
      portNumber: 9,
      deviceName: 'RTUS00129SCP004',
      isAssociated: false,
      associatedDevice: 'unavailable',
      manufacturer: 'Epson',
      model: 'EPSON TM-m30III',
      serialNumber: 'XBVN007565',
    },
    alerts: [],
  },
];

const barcodeScannerList: Device<BarCodeScanDetails>[] = [];

const cashDrawersList: Device<CashDrawerScanDetails>[] = [];

const paymentTerminalsList: Device<PaymentTerminalScanDetails>[] = [
  {
    scanResults: {
      isInDatabase: false,
      isInLiveData: false,
      associatedNposRegisterIsInLiveData: false,
      isOnline: false,
      ipAddress: '10.146.57.126',
      macAddress: '60:c7:98:5a:d1:23',
      vlanNumber: '5',
      switchId: 'NNRTST1X01',
      switchNumber: '2',
      portNumber: '5',
      deviceName: 'M400-402011011',
      isAssociated: true,
      associatedDevice: 'HW6JFXM-WS1',
      manufacturer: 'Verifone',
      model: 'M400',
      serialNumber: '402011011',
    },
    alerts: [],
  },
  {
    scanResults: {
      isInDatabase: false,
      isInLiveData: false,
      associatedNposRegisterIsInLiveData: false,
      isOnline: false,
      ipAddress: 'unavailable',
      macAddress: 'unavailable',
      vlanNumber: 'N/A',
      switchId: 'N/A',
      switchNumber: 'unavailable',
      portNumber: 'unavailable',
      deviceName: 'unavailable',
      isAssociated: false,
      associatedDevice: 'HW6JFXM-WS2',
      manufacturer: 'unavailable',
      model: 'unavailable',
      serialNumber: 'unavailable',
    },
    alerts: [
      {
        alertType: AlertType.SCAN_FAILURE_ALERT,
        alertDefinitionId: 'ScanFailure',
        deviceType: DeviceType.PAYMENT_TERMINAL,
        scanSubType: AlertScanSubType.HARDWARE,
        siteImpact: 'ScanFailure',
        shortDescription: 'There was an error while scanning NPOS Payment Terminals.',
        description:
          'The error may be related to an issue when attempting to reach an external source, or an unknown error occurred.',
      },
    ],
  },
  {
    scanResults: {
      isInDatabase: false,
      isInLiveData: false,
      associatedNposRegisterIsInLiveData: false,
      isOnline: false,
      ipAddress: 'unavailable',
      macAddress: 'unavailable',
      vlanNumber: 'N/A',
      switchId: 'N/A',
      switchNumber: 'unavailable',
      portNumber: 'unavailable',
      deviceName: 'unavailable',
      isAssociated: true,
      associatedDevice: 'HW6JFXM-WS3',
      manufacturer: 'unavailable',
      model: 'unavailable',
      serialNumber: 'unavailable',
    },
    alerts: [],
  },
];

export default {
  cloudServices: cloudServicesList,
  networkCircuits: networkCircuitList,
  networkSwitchesList: networkSwitchesList,
  registers: registersList,
  consumerFacingDisplays: consumerFacingDisplaysList,
  receiptPrinters: receiptPrintersList,
  barcodeScanners: barcodeScannerList,
  cashDrawers: cashDrawersList,
  paymentTerminals: paymentTerminalsList,
};
